<template>
  <div id="app" class="kpt-portal" :class="{ 'kpt-theme-light': isTheme('light'), 'kpt-theme-dark': isTheme('dark'), 'kpt-theme-kymeta': isTheme('kymeta') }">
    <app-loader v-if="!appIsLoaded"></app-loader>
    <template v-if="appIsLoaded && !publicRoutes.includes($route.name)">
      <top-bar v-show="isAuthenticated"></top-bar>
      <global-notification></global-notification>
      <portal-main v-show="isAuthenticated"></portal-main>
      <logged-out v-if="isLoggedOut"></logged-out>
    </template>
    <router-view name="public"></router-view>
    <router-view name="configurator"></router-view>
    <router-view name="maintenance"></router-view>
  </div>
</template>
<script>
import TopBar from './layout/TopBar.vue';
import GlobalNotification from './layout/GlobalNotification.vue';
import PortalMain from './layout/PortalMain.vue';
import LoggedOut from './system/LoggedOut.vue';
import AppLoader from './system/AppLoader.vue';

export default {
  created() {
    this.$store.commit('setAppIsLoaded', false);
    if (this.$kya) this.$kya.init();
  },
  data() {
    return {
      isLoggedOut: false
    }
  },
  async mounted() {
    this.$store.commit('setAppIsLoaded', false);
    if (this.$auth.isAuthenticated) {
      const health = await this.$store.dispatch('fetchAppHealth');
      if (health) {
        await this.loadRequiredArtifacts();
      } else {
        this.$router.push('/maintenance');
      }
    }
    this.$store.commit('setAppIsLoaded', true);
  },
  components: {
    'top-bar': TopBar,
    'global-notification': GlobalNotification,
    'portal-main': PortalMain,
    'logged-out': LoggedOut,
    'app-loader': AppLoader
  },
  computed: {
    theme() {
      return this.$store.state.user.settings.theme;
    },
    defaultStartRoute() {
      return this.$store.state.user.settings.defaultStartRoute;
    },
    isAuthenticated() {
      return this.$auth.isAuthenticated;
    },
    appIsLoaded() {
      return this.$store.state.appLoaded;
    },
    publicRoutes() {
      return this.$router.options.routes.filter(r => r.meta.public).map(r => r.name);
    }
  },
  methods: {
    isTheme(theme) {
      // TODO: actually wire this
      return theme == this.theme;
    },
    async loadRequiredArtifacts() {
      this.$store.commit('setAppIsLoaded', false);

      try {
        await this.$store.dispatch('loadApplication');
        this.$store.dispatch('loadApplicationInBackground');
        await this.$store.dispatch('listenForNotifications');
      } catch (ex) {
        return false;
      } finally {
        this.$store.commit('setAppIsLoaded', true);
      }
      return true;
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    isAuthenticated(newvalue) {
      if (newvalue === false) {
        setTimeout(() => {
          this.isLoggedOut = true;
        }, 1000);
      }
    }
  }
}
</script>
<style lang="scss">
// Import root app styles
@import './styles/styles.scss';
// Set body parameters
html, body {
  height: 100%;
  overflow: hidden;
}
body {
  //https://css-tricks.com/snippets/css/system-font-stack/
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<style lang="scss">
@import './styles/_colors';

.kpt-portal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 0;
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  max-height: 100vh;
}
</style>
